import React from 'react'
import ProductV2 from './pages/products/ProductV2';
import ProductCategory from './pages/products/Category';
import OrderV2 from './pages/orders/OrderV2';
import CheckoutEdit from './pages/checkouts/CheckoutEdit';
import OrderCreate from './pages/orders/OrderCreate/OrderCreate';
import OrderCreateV2 from './pages/orders/OrderCreate/OrderCreateV2';
import OrderEdit from './pages/orders/OrderEdit/OrderEdit';
import CustomerV2 from './pages/customers/CustomerV2';
import Discount from './pages/discounts/Discount';
import PageDiscountCode from './pages/discounts/components/PageDiscountCodeV4';

import PageCheckout from './pages/page_checkouts/PageCheckout';
import PageCheckoutUpdate from './pages/page_checkouts/components/PageCheckoutUpdate';

import PageCheckoutCreateV2 from './pages/page_checkouts/pageCheckoutCreate/PageCheckoutCreateV2';

import PageCheckoutCreateSDK from './pages/page_checkouts/components/PageCheckoutCreateSDK';
import PageCheckoutUpdateSDK from './pages/page_checkouts/components/PageCheckoutUpdateSDK';

import ReportV4 from './pages/reports/ReportV4';
import AssigneeOverTime from './pages/reports/AssigneeOverTime';
import OrderOverTime from './pages/reports/OrderOverTime';
import Setting from './pages/settings/Setting';
import ShippingEdit from './pages/shippings/ShippingEdit';

import ProductCreateV4 from './pages/products/components/ModalCreate/ProductCreateV4';
import ProductCourseCreate from './pages/courses/components/ModalCreate/ProductCourseCreate';
import ProductCourseUpdate from './pages/courses/components/ModalEdit/ModalEditCourse';

import ModalEventV4 from './pages/events/components/ModalEventV4';
import DigitalCreate from './pages/products/digital/DigitalCreate';
import ModalServiceV4 from './pages/services/components/ModalServiceV4';

import Checkin from './pages/products/Checkin';
import CheckQrcode from './pages/products/CheckQrCode';
import CheckinInfoHandle from './pages/products/CheckinInfoHandle';
import { map } from 'lodash';
import Upgrade from './pages/upgrades/Upgrade';
import Inventory from './pages/products/Inventory';
import Integrate from './pages/integrates/Integrate';
import IntegrateV4 from './pages/integrates/integrateV4';
import StorePage from './pages/store_page/StorePage';
import HomePageCreate from './pages/store_page/components/StorePageCreate';

import CourseV2 from './pages/courses/CourseV2';
import CourseWelcome from './pages/courses/components/Welcome';

import PageManageReview from './pages/products/components/PageManageReviews';

import PanelPageCategoryInfo from './pages/products/components/PanelPageCategoryInfo';
import PanelPageAddReview from './pages/products/components/PanelPageAddReview';

import i18n from './i18n';
import PageCourse from './pages/courses/PageCourse';
import PageStudentManagement from './pages/courses/PageStudentManagement';
import CourseCategory from './pages/products/CourseCategory';

const allRoutes = {
    '/orders': [
        { path: '/orders', exact: true, name: `${i18n.t('MENU.ORDERS')}`, component: OrderV2 },
        { path: '/checkouts/:checkoutID', exact: true, component: CheckoutEdit },
        { path: '/orders/create', exact: true, component: OrderCreateV2 },
        { path: '/orders/create-old', exact: true, component: OrderCreate },
        { path: '/orders-old/:orderID', exact: true, component: OrderEdit },
        { path: '/orders/:orderID', exact: true, component: OrderCreateV2 },
        { path: '/shippings/:shippingID', exact: true, name: `${i18n.t('MENU.SHIPPINGS')}`, component: ShippingEdit },
    ],
    '/products': [
        { path: '/products', exact: true, name: `${i18n.t('MENU.PRODUCTS')}`, component: ProductV2 },
        { path: '/products/create', exact: true, name: `${i18n.t('MENU.PRODUCTS')}`, component: ProductCreateV4 },
        { path: '/products/update/:productID', exact: true, name: `${i18n.t('MENU.PRODUCTS')}`, component: ProductCreateV4 },
        { path: '/inventory', exact: true, name: `${i18n.t('MENU.INVENTORY')}`, component: Inventory },
        { path: '/product-category', exact: true, name: `${i18n.t('MENU.CATEGORY_PRODUCT')}`, component: ProductCategory },
        { path: '/product-category/create', exact: true, name: `${i18n.t('MENU.CATEGORY_PRODUCT')}`, component: PanelPageCategoryInfo },
        {
            path: '/product-category/update/:productCategoryID',
            exact: true,
            name: `${i18n.t('MENU.CATEGORY_PRODUCT')}`,
            component: PanelPageCategoryInfo,
        },
        { path: '/product-manage-reviews', exact: true, name: `${i18n.t('MENU.MANAGE_REVIEWS')}`, component: PageManageReview },
        { path: '/product-manage-reviews/create', exact: true, name: `${i18n.t('MENU.MANAGE_REVIEWS')}`, component: PanelPageAddReview },
    ],
    '/digital': [
        { path: '/digital/create', exact: true, name: `${i18n.t('MENU.PRODUCTS')}`, component: DigitalCreate },
        { path: '/digital/update/:productID', exact: true, name: `${i18n.t('MENU.PRODUCTS')}`, component: DigitalCreate },
    ],

    '/courses': [
        { path: '/courses', exact: true, name: `${i18n.t('MENU.COURSES')}`, component: CourseV2 },
        { path: '/courses/create', exact: true, name: `${i18n.t('MENU.COURSES')}`, component: ProductCourseCreate },
        { path: '/courses/update/:productID', exact: true, name: `${i18n.t('MENU.COURSES')}`, component: ProductCourseUpdate },
        { path: '/page-course', exact: true, name: `${i18n.t('MENU.PAGE_COURSE')}`, component: PageCourse },
        { path: '/student-management', exact: true, name: `${i18n.t('COURSES.STUDENT_MANAGEMENT')}`, component: PageStudentManagement },
        { path: '/course-category', exact: true, name: `${i18n.t('MENU.CATEGORY_COURSE')}`, component: (props) => <CourseCategory {...props} selectedProductType='Course'/> },
    ],
    '/events': [
        { path: '/events/create', exact: true, name: `${i18n.t('MENU.PRODUCTS')}`, component: ModalEventV4 },
        { path: '/events/update/:productID', exact: true, name: `${i18n.t('MENU.PRODUCTS')}`, component: ModalEventV4 },
    ],
    '/services': [
        { path: '/services/create', exact: true, name: `${i18n.t('MENU.PRODUCTS')}`, component: ModalServiceV4 },
        { path: '/services/update/:productID', exact: true, name: `${i18n.t('MENU.PRODUCTS')}`, component: ModalServiceV4 },
    ],
    '/customers': [
        {
            path: '/customers',
            exact: true,
            name: `${i18n.t('MENU.CUSTOMERS')}`,
            component: CustomerV2,
        },
    ],
    '/discounts': [
        { path: '/discounts', exact: true, name: `${i18n.t('MENU.DISCOUNTS')}`, component: Discount },
        { path: '/discount-promotion/create', exact: true, name: `${i18n.t('MENU.DISCOUNTS')}`, component: PageDiscountCode },
        { path: '/discount-promotion/update/:discountID', exact: true, name: `${i18n.t('MENU.DISCOUNTS')}`, component: PageDiscountCode },
    ],
    '/checkin': [{ path: '/checkin', exact: true, name: `${i18n.t('MENU.DISCOUNTS')}`, component: Checkin }],
    '/check-qrcode': [{ path: '/check-qrcode', exact: true, name: `${i18n.t('MENU.DISCOUNTS')}`, component: CheckQrcode }],
    '/checkin/info-handle': [
        { path: '/checkin/info-handle', exact: true, name: `${i18n.t('MENU.DISCOUNTS')}`, component: CheckinInfoHandle },
    ],
    '/reports': [
        { path: '/reports', exact: true, name: `${i18n.t('MENU.REPORTS')}`, component: ReportV4 },
        { path: '/reports/orders_over_time', exact: true, component: OrderOverTime },
        { path: '/reports/assignees_over_time', exact: true, component: AssigneeOverTime },
    ],
    '/settings': [{ path: '/settings', exact: true, name: `${i18n.t('MENU.SETTINGS')}`, component: Setting }],
    '/upgrade': [{ path: '/upgrade', exact: true, name: `${i18n.t('MENU.UPGRADE')}`, component: Upgrade }],
    '/page-checkout': [
        { path: '/page-checkout', exact: true, name: `${i18n.t('MENU.PAGE_CHECKOUT')}`, component: PageCheckout },
        {
            path: '/page-checkout/update/:pageCheckoutID',
            exact: true,
            name: `${i18n.t('MENU.PAGE_CHECKOUT')}`,
            component: PageCheckoutCreateV2,
        },
        {
            path: '/page-checkout/update-old/:pageCheckoutID',
            exact: true,
            name: `${i18n.t('MENU.PAGE_CHECKOUT')}`,
            component: PageCheckoutUpdate,
        },
        { path: '/page-checkout/create', exact: true, name: `${i18n.t('MENU.PAGE_CHECKOUT')}`, component: PageCheckoutCreateV2 },
        { path: '/page-checkout/sdk-create', exact: true, name: `${i18n.t('MENU.PAGE_CHECKOUT')}`, component: PageCheckoutCreateSDK },
        {
            path: '/page-checkout/sdk-update/:pageCheckoutID',
            exact: true,
            name: `${i18n.t('MENU.PAGE_CHECKOUT')}`,
            component: PageCheckoutUpdateSDK,
        },
        { path: '/store-page', exact: true, name: `${i18n.t('STORES.EDIT_STORE')}`, component: StorePage },
        { path: '/store-page/create', exact: true, name: `${i18n.t('STORES.EDIT_STORE')}`, component: HomePageCreate },
        {
            path: '/store-page/update/:storePageID',
            exact: true,
            name: `${i18n.t('STORES.EDIT_STORE')}`,
            component: PageCheckoutCreateV2,
        },
    ],
    '/page-course/welcome': [
        { path: '/page-course/welcome', exact: true, name: `${i18n.t('MENU.PAGE_COURSE')}`, component: CourseWelcome },
    ],
    '/integrate': [{ path: '/integrate', exact: true, name: `${i18n.t('MENU.INTEGRATE')}`, component: Integrate }],
};

const menuItems = {
    '/orders': {
        keyStr: ['orders', 'shippings', 'my-orders', 'checkouts', ''],
        key: 'orders',
        classLi: 'ladiui menu-item',
        to: '/orders',
        classNav: 'ladiui flex-row-menu-item dropdown-toggle',
        classIcon: 'ladi-icon icon new-ldicon-inbox',
        title: 'MENU.ORDERS',
        children: [
            {
                classLi: 'ladiui menu-child-item',
                to: '/my-orders',
                classLink: 'ladiui subtitle-2',
                title: 'MENU.MY_ORDERS',
            },
            {
                classLi: 'ladiui menu-child-item',
                to: '/orders',
                classLink: 'ladiui subtitle-2',
                title: 'MENU.ALL_ORDERS',
            },
            {
                classLi: 'ladiui menu-child-item',
                to: '/checkouts',
                classLink: 'ladiui subtitle-2',
                title: 'MENU.UNFINISH_ORDERS',
            },
            {
                classLi: 'ladiui menu-child-item',
                to: '/shippings',
                classLink: 'ladiui subtitle-2',
                title: 'MENU.SHIPPINGS',
            },
        ],
    },
    '/products': {
        keyStr: ['products', 'inventory', 'product-category', 'product-manage-reviews'],
        key: 'products',
        classLi: 'ladiui menu-item',
        to: '/products',
        classNav: 'ladiui flex-row-menu-item dropdown-toggle',
        classIcon: 'new-ldicon-box ladiui icon-new icon-24',
        title: 'MENU.PRODUCTS',
        children: [
            {
                classLi: 'ladiui menu-child-item',
                to: '/products',
                classLink: 'ladiui subtitle-2',
                title: 'MENU.SUB_MENU_PRODUCTS',
            },
            {
                classLi: 'ladiui menu-child-item',
                to: '/inventory',
                classLink: 'ladiui subtitle-2',
                title: 'MENU.INVENTORY',
            },
            {
                classLi: 'ladiui menu-child-item',
                to: '/product-category?type=Product',
                classLink: 'ladiui subtitle-2',
                title: 'MENU.CATEGORY',
            },
            {
                classLi: 'ladiui menu-child-item',
                to: '/product-manage-reviews',
                classLink: 'ladiui subtitle-2',
                title: 'MENU.MANAGE_REVIEWS',
            },
        ],
    },
    '/courses': {
        keyStr: ['courses', 'page-course', 'student-management', 'course-category'],
        key: 'courses',
        classLi: 'ladiui menu-item',
        to: '/courses',
        classNav: 'ladiui flex-row-menu-item dropdown-toggle',
        classIcon: 'ladi-icon icon icon-menu-courses',
        title: 'MENU.COURSES',
        children: [
            {
                classLi: 'ladiui menu-child-item',
                to: '/courses',
                classLink: 'ladiui subtitle-2',
                title: 'Danh sách khóa học',
            },
            {
                classLi: 'ladiui menu-child-item',
                to: '/course-category?type=Course',
                classLink: 'ladiui subtitle-2',
                title: 'Danh mục',
            },
            {
                classLi: 'ladiui menu-child-item',
                to: '/student-management',
                classLink: 'ladiui subtitle-2',
                title: 'Quản lý học viên',
            },
            {
                classLi: 'ladiui menu-child-item',
                to: '/page-course',
                classLink: 'ladiui subtitle-2',
                title: 'Thiết lập giao diện',
            },
        ],
    },
    '/page-checkout': {
        keyStr: ['page-checkout', 'store-page'],
        key: 'page-checkout',
        classLi: 'ladiui menu-item',
        to: '/page-checkout',
        classNav: 'ladiui flex-row-menu-item dropdown-toggle',
        classIcon: 'ladiui icon-new icon-24 new-ldicon-checkout',
        title: 'MENU.SALES_CHANNEL',
        children: [
            {
                classLi: 'ladiui menu-child-item',
                to: '/page-checkout',
                classLink: 'ladiui subtitle-2',
                title: 'MENU.PAGE_SALES',
            },
            {
                classLi: 'ladiui menu-child-item',
                to: '/store-page',
                classLink: 'ladiui subtitle-2',
                title: 'STORES.TITLE',
            },
        ],
    },
    '/customers': {
        keyStr: ['customers'],
        key: 'customers',
        classLi: 'ladiui menu-item',
        to: '/customers',
        classNav: 'ladiui flex-row-menu-item',
        classIcon: 'new-ldicon-user ladiui icon-new icon-24',
        title: 'MENU.CUSTOMERS',
    },
    '/discounts': {
        keyStr: ['discounts', 'discount-promotion', 'discount-promotion'],
        key: 'discounts',
        classLi: 'ladiui menu-item',
        to: '/discounts',
        classNav: 'ladiui flex-row-menu-item',
        classIcon: 'new-ldicon-coupon ladiui icon-new icon-24',
        title: 'MENU.DISCOUNTS',
    },
    '/integrate': {
        keyStr: ['integrate'],
        key: 'integrate',
        classLi: 'ladiui menu-item',
        to: '/integrate',
        classNav: 'ladiui flex-row-menu-item',
        classIcon: 'ladi-icon  icon icon-menu-integrates',
        title: 'MENU.INTEGRATE',
    },
    '/reports': {
        keyStr: ['reports'],
        key: 'reports',
        classLi: 'ladiui menu-item',
        to: '/reports',
        classNav: 'ladiui flex-row-menu-item',
        classIcon: 'ladi-icon  icon icon-menu-reports',
        title: 'MENU.REPORTS',
    },
    '/settings': {
        keyStr: ['settings'],
        key: 'settings',
        classLi: 'ladiui menu-item',
        to: '/settings',
        classNav: 'ladiui flex-row-menu-item',
        classIcon: 'ladi-icon  icon icon-menu-settings',
        title: 'MENU.SETTINGS',
    },
};

class Routes {
    getRoutesByScopes(scopes = {}, is_show_course) {
        const routes = [];
        // if (scopes.admin) {
        map(allRoutes, (values, key) => {
            if ((is_show_course && key == '/courses') || key != '/courses') {
                routes.push(...values);
            }
        });
        return routes;
    }

    getItemByScopes(scopes = {}) {
        return menuItems;
    }
}

export default new Routes();
